import { useEffect, useState } from "react";
import { LuX } from "react-icons/lu";
import { LuCheck } from "react-icons/lu";
import Skeleton from "react-loading-skeleton";
import PageHeader from "src/components/PageHeader";
import TwinButton from "src/components/TwinButton";
import WhiteBoard from "src/components/WhiteBoard";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import RoleDescriptionBtn from "./RoleDescriptionBtn";

export const permissions = {
  // generals
  "viewDashboard": <RoleDescriptionBtn title="مشاهده پیشخوان" color="#00bf63" category="عمومی" />,
  // users
  "viewUsersMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت دسترسی" color="#8c52ff" category="کاربران" />,
  "viewUserList": <RoleDescriptionBtn title="مشاهده لیست کاربران" color="#8c52ff" category="کاربران" />,
  "editUserPermission": <RoleDescriptionBtn title="ویرایش سطح دسترسی" color="#8c52ff" category="کاربران" />,
  "createNewUser": <RoleDescriptionBtn title="ایجاد کاربر جدید" color="#8c52ff" category="کاربران" />,
  "editUser": <RoleDescriptionBtn title="ویرایش کاربر" color="#8c52ff" category="کاربران" />,
  "deleteUser": <RoleDescriptionBtn title="حذف کاربر" color="#8c52ff" category="کاربران" />,
  "exportUsers": <RoleDescriptionBtn title="خروجی CSV کاربران" color="#8c52ff" category="کاربران" />,
  // financial
  "viewSalesMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت مالی" color="#ff914d" category="مالی" />,
  "financialViewSalesList": <RoleDescriptionBtn title="مشاهده لیست فروش‌ها" color="#ff914d" category="مالی" />,
  "viewSalesReport": <RoleDescriptionBtn title="مشاهده گزارش فروش‌ها" color="#ff914d" category="مالی" />,
  "viewSalesInvoice": <RoleDescriptionBtn title="مشاهده فاکتورهای فروش" color="#ff914d" category="مالی" />,
  "viewFailedInvoice": <RoleDescriptionBtn title="مشاهده فاکتورهای خطادار" color="#ff914d" category="مالی" />,
  "exportSales": <RoleDescriptionBtn title="خروجی CSV فروش‌ها" color="#ff914d" category="مالی" />,
  // products
  "viewProductsMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت محصولات" color="#004aad" category="محصولات" />,
  "viewProductsList": <RoleDescriptionBtn title="مشاهده لیست محصولات" color="#004aad" category="محصولات" />,
  "viewUpdateByExcel": <RoleDescriptionBtn title="دسترسی ویرایش با اکسل" color="#004aad" category="محصولات" />,
  "exportProducts": <RoleDescriptionBtn title="خروجی CSV محصولات" color="#004aad" category="محصولات" />,
  // orders
  "viewOrdersMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت سفارشات" color="#ff3131" category="سفارشات" />,
  "viewOrdersList": <RoleDescriptionBtn title="مشاهده لیست سفارش‌ها" color="#ff3131" category="سفارشات" />,
  "viewOrdersListAll": <RoleDescriptionBtn title="مشاهده لیست سفارش‌ها (کلی)" color="#ff3131" category="سفارشات" />,
  "exportOrders": <RoleDescriptionBtn title="خروجی CSV سفارش‌ها" color="#ff3131" category="سفارشات" />,
  "changeOrdersStatus": <RoleDescriptionBtn title="تغییر وضعیت سفارش ها" color="#ff3131" category="سفارشات" />,
  "viewOrdersPhoneNumber": <RoleDescriptionBtn title="مشاهده ستون شماره تماس در لیست سفارش‌ها" color="#ff3131" category="سفارشات" />,
  "viewOrdersOperation": <RoleDescriptionBtn title="مشاهده ستون عملیات در لیست سفارش‌ها" color="#ff3131" category="سفارشات" />,
  // commercial
  "viewCommercialMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت بازرگانی" color="#5b3c1d" category="بازرگانی" />,
  "productsStatistics": <RoleDescriptionBtn title="لیست محصولات (آمار فروش)" color="#5b3c1d" category="بازرگانی" />,
  "exportProductsStatistics": <RoleDescriptionBtn title="لیست محصولات (آمار فروش) خروجی CSV" color="#5b3c1d" category="بازرگانی" />,
  // marketing
  "viewMarketingMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت فروش" color="#1f2937" category="فروش" />,
  "marketingViewSalesList": <RoleDescriptionBtn title="مشاهده لیست فروش‌ها" color="#1f2937" category="فروش" />,
  "exportMarketingSales": <RoleDescriptionBtn title="خروجی CSV فروش‌ها" color="#1f2937" category="فروش" />,
  "marketingVouchersList": <RoleDescriptionBtn title="مشاهده آمار کدهای تخفیف" color="#1f2937" category="فروش" />,
  "exportMarketingVouchers": <RoleDescriptionBtn title="خروجی CSV آمار کدهای تخفیف" color="#1f2937" category="فروش" />,
  "marketingSalesVelocityList": <RoleDescriptionBtn title="مشاهده آمار سرعت فروش محصولات" color="#1f2937" category="فروش" />,
  "exportMarketingSalesVelocity": <RoleDescriptionBtn title="خروجی CSV سرعت فروش محصولات" color="#1f2937" category="فروش" />,
  "viewReturningCustomers": <RoleDescriptionBtn title="مشاهده آمار خریداران" color="#1f2937" category="فروش" />,
  "exportReturningCustomers": <RoleDescriptionBtn title="خروجی CSV آمار خریداران" color="#1f2937" category="فروش" />,
  // warehouse
  "viewWarehouseMenu": <RoleDescriptionBtn title="مشاهده منو مدیریت انبار" color="#09bcc1" category="انبار" />,
  "viewSepidarSync": <RoleDescriptionBtn title="مشاهده تطابق سایت و سپیدار" color="#09bcc1" category="انبار" />,
  "viewInbounds": <RoleDescriptionBtn title="مشاهده مدیریت محموله‌ها" color="#09bcc1" category="انبار" />,
  "viewSellersInbounds": <RoleDescriptionBtn title="مشاهده لیست محموله‌ها فروشندگان" color="#09bcc1" category="انبار" />,
  "exportInventory": <RoleDescriptionBtn title="خروجی CSV انبار" color="#09bcc1" category="انبار" />,
  // seller
  "viewInbounds": <RoleDescriptionBtn title="مشاهده لیست محموله‌ها" color="#c72323" category="سلر" />,
  "viewSellerProductsList": <RoleDescriptionBtn title="مشاهده لیست محصولات سلر" color="#c72323" category="سلر" />,
  "viewSellerOrdersList": <RoleDescriptionBtn title="مشاهده لیست سفارشات سلر" color="#c72323" category="سلر" />,
  "viewSellerSalesList": <RoleDescriptionBtn title="مشاهده لیست فروش‌ها سلر" color="#c72323" category="سلر" />,
  // settings
  "viewSettingsMenu": <RoleDescriptionBtn title="مشاهده منو تنظیمات" color="#aa6f73" category="سیستم" />,
  "changePassword": <RoleDescriptionBtn title="مشاهده منو تغییر رمز عبور" color="#aa6f73" category="سیستم" />,
}

export default function Roles() {

  const [isLoading, setIsLoading] = useState(false)

  const getRoles = async () => {
    const result = await get("/roles");
    setAllRoles(result.data.map(function (single) {
      return {
        role: single.name,
        permissions: JSON.parse(single.permissions),
        roleTranslate: single.description
      }
    }))
  }

  useEffect(() => {
    getRoles();
  }, [])

  const [allRoles, setAllRoles] = useState(false);

  const handleUpdateAccess = (index, key) => {
    // super Admin roles can't change
    if (index == 0) {
      return;
    }
    // others can
    setAllRoles((prevRoles) => {
      const updatedRoles = [...prevRoles];
      const role = updatedRoles[index];

      if (role?.permissions?.includes(key)) {
        role.permissions = role.permissions.filter((access) => access !== key);
      } else {
        role.permissions = [...role.permissions, key];
      }
      return updatedRoles;
    });
  };

  const submitChanges = async () => {
    setIsLoading(true)
    let result = await post("/roles", allRoles)
    if (result.success) {
      notify("تمام نقش‌ها با موفقیت به روز رسانی شدند")
    } else {
      notify("خطایی رخ داده است", "error")
    }
    setIsLoading(false)
  }

  return (
    <>
      <PageHeader
        title="نقش های سیستم"
      />
      {
        allRoles
          ?
          <WhiteBoard>
            <table className="min-w-full divide-y divide-gray-200 border">
              <thead>
                <tr>
                  <th className="sticky top-0 px-1.5 py-3 border border-white text-bold bg-gray-800  text-center text-xs leading-4   text-white  tracking-wider">
                    دسترسی / نقش
                  </th>
                  {allRoles.map((role) => {
                    return (
                      <th className="sticky top-0 px-1.5 py-3 border border-white text-bold bg-primary-color  text-center text-xs leading-4   text-white  tracking-wider">
                        {role.roleTranslate}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {Object.keys(permissions).map(permission => (
                  <tr
                    classNameName="border-gray-100"
                  >
                    <td className="select-none px-1.5 py-4 text-bold text-center text-xs  border border-gray-100">
                      {permissions[permission]}
                    </td>
                    {allRoles.map((role, index) => {
                      return (
                        <td
                          className="px-1.5   border border-gray-100 cursor-pointer py-4 text-bold text-xs"
                          onClick={() => handleUpdateAccess(index, permission)}
                        >
                          <span className="flex items-center justify-center">
                            {role?.permissions?.includes(permission) || role.permissions == "SUPER_USER_PERMISSIONS" ? (
                              <LuCheck
                                size={24}
                                style={{ color: "#34d399" }}
                              />
                            ) : (
                              <LuX
                                size={24}
                                style={{ color: "#fb7185" }}
                              />
                            )}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex flex-row justify-end items-end mt-8">
              <TwinButton
                isCompact={true}
                rejectTitle={false}
                acceptHandle={submitChanges}
                isLoading={isLoading}
              />
            </div>
          </WhiteBoard>
          :
          <Skeleton height={57} count={10} className="rounded-lg" />
      }

    </>
  );
}